import TestimonialCarousel from "../../components/TestimonialCarousel";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const TestimonialSlider = () => {
  return (
    <div className="testimonial-slider">
      <TestimonialCarousel images={CONSTANTS.testimonialSlides} />
    </div>
  );
};
export default TestimonialSlider;
